import "./Header.css";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logoLine from "../../../images/LogoLine.svg";
// import logoMobile from '../../../images/IClimbTreesLogo2.svg';
import logoMobile from "../../../images/IClimbTreesLogo.png";

import AuthModal from "./AuthModal";
import { LOGOUT } from "../../../constants/userConstants";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import decode from "jwt-decode";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [authMode, setAuthMode] = useState(null); // null | 'signin' | 'signup'
  const dropdownRef = useRef(null);

  const openAuth = (mode) => {
    setAuthMode(mode);
    setMenuOpen(false);
  };
  const closeAuth = () => setAuthMode(null);

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  console.log(user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!dropdownOpen) return;
    const onPointerDown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [dropdownOpen]);

  /** @param {React.KeyboardEvent} e */
  const handleAvatarKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setDropdownOpen((v) => !v);
    }
    if (e.key === "Escape") setDropdownOpen(false);
  };

  const handleLogout = () => {
    setDropdownOpen(false);
    dispatch({ type: LOGOUT });
    navigate("/");
    setUser(null);
  };

  // Called when location is changed
  useEffect(() => {
    setDropdownOpen(false);
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime()) {
        dispatch({ type: LOGOUT });
        navigate("/");
        setUser(null);
      }
    }

    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location, user?.token, dispatch, navigate]);

  return (
    <>
      <header className={`header${scrolled ? " header--scrolled" : ""}`}>
        <div className="header__inner container">
          <Link to="/" className="header__logo" aria-label="IClimbTrees home">
            <img
              src={logoLine}
              alt="IClimbTrees"
              height="36"
              className="header__logo-desktop"
            />
            <img
              src={logoMobile}
              alt="IClimbTrees"
              height="36"
              className="header__logo-mobile"
            />
          </Link>

          <div className="header__actions">
            {user ? (
              <>
                <button
                  className="header__icon-btn"
                  onClick={() => navigate("/bookmarks")}
                  aria-label="My bookmarks"
                  title="My bookmarks"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 14 14"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M3 2h8v10L7 9.5 3 12V2z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="header__avatar-wrap" ref={dropdownRef}>
                  <button
                    className="header__avatar"
                    onClick={() => setDropdownOpen((v) => !v)}
                    onKeyDown={handleAvatarKey}
                    aria-label="Account menu"
                    aria-haspopup="true"
                    aria-expanded={dropdownOpen}
                  >
                    {user?.result?.imageUrl ? (
                      <img
                        src={user?.result?.imageUrl}
                        alt={user?.result?.name}
                        className="header__avatar-img"
                      />
                    ) : (
                      <span
                        className="header__avatar-initial"
                        aria-hidden="true"
                      >
                        {user?.result?.name?.charAt(0)}
                      </span>
                    )}
                  </button>

                  {dropdownOpen && (
                    <div className="header__dropdown" role="menu">
                      <p className="header__dropdown-name">
                        {user?.result?.name}
                      </p>
                      <hr className="header__dropdown-divider" />
                      <button
                        className="header__dropdown-item"
                        role="menuitem"
                        onClick={handleLogout}
                      >
                        Log out
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <button
                  className="btn btn--ghost"
                  aria-label="Log in"
                  onClick={() => openAuth("signin")}
                >
                  Log in
                </button>
                <button
                  className="btn btn--primary"
                  aria-label="Sign up for free"
                  onClick={() => openAuth("signup")}
                >
                  Sign up for free
                </button>
              </>
            )}
          </div>

          <button
            className={`header__burger${menuOpen ? " header__burger--open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {menuOpen && (
          <div
            className="header__mobile-overlay"
            onClick={() => setMenuOpen(false)}
          >
            <div
              className="header__mobile-menu"
              onClick={(e) => e.stopPropagation()}
            >
              {user ? (
                <div className="header__mobile-user">
                  <div className="header__mobile-avatar">
                    {user?.result?.imageUrl ? (
                      <img
                        src={user?.result?.imageUrl}
                        alt={user?.result?.name}
                        className="header__avatar-img"
                      />
                    ) : (
                      <span
                        className="header__avatar-initial"
                        aria-hidden="true"
                      >
                        {user?.result?.name?.charAt(0)}
                      </span>
                    )}
                  </div>
                  <span className="header__mobile-name">
                    {user?.result?.name}
                  </span>
                  <hr
                    className="header__dropdown-divider"
                    style={{ margin: "0.75rem 0" }}
                  />
                  <button
                    className="btn btn--ghost btn--full"
                    onClick={() => {
                      setMenuOpen(false);
                      handleLogout();
                    }}
                  >
                    Log out
                  </button>
                </div>
              ) : (
                <div className="header__mobile-actions">
                  <button
                    className="btn btn--ghost btn--full"
                    onClick={() => openAuth("signin")}
                  >
                    Log in
                  </button>
                  <button
                    className="btn btn--primary btn--full"
                    onClick={() => openAuth("signup")}
                  >
                    Sign up for free
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </header>

      {authMode && <AuthModal initialMode={authMode} onClose={closeAuth} />}
    </>
  );
}
